const s = {
  name: "UserDeveloper",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h14c6.1,0,11,4.9,11,11v11h-2V29c0-5-4-9-9-9H11c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M19,33c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S19,32.5,19,33z"/>
		<path class="st0" d="M27,29v9h3v2H6v-2h3v-9c0-1.7,1.3-3,3-3h12C25.7,26,27,27.4,27,29z M11,29v9h14v-9c0-0.5-0.5-1-1-1H12
			C11.5,28,11,28.5,11,29z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserDeveloper
};
